<div class="form_group search">
  <mat-form-field appearance="fill">
    <input
      #search
      matInput
      [placeholder]="placeholder"
      class="form_control"
      (focus)="onFocus()"
      (focusout)="showDropdown.set(false)"
      (keydown.enter)="onEnter(search.value)"
      [formControl]="formControl" />
  </mat-form-field>
  <button mat-button matPrefix mat-icon-button class="btnn">
    <figure *ngIf="!showCrossIcon()">
      <img src="{{ assetsConst.searchIcon }}" alt="searchIcon" />
    </figure>
    <mat-icon *ngIf="showCrossIcon()" (click)="clearInputField()"
    >close
    </mat-icon
    >
  </button>

  <ng-container *ngIf="dropdownData$ | async as dropDownItems">
    <div *ngIf="showDropdown()" class="dropdown">
      <mat-list>
        <mat-list-item
          *ngFor="let item of dropDownItems"
          (mousedown)="onSelectItem(item.searchText)">
          {{ item.searchText }}
        </mat-list-item>
      </mat-list>
    </div>
  </ng-container>
</div>
